import { BooleanFilterEnum } from '../../../shared';
import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { LocationTypeEnum } from '../../../tenant/locations/enums/location-type.enum';

/**
 * Proto locations filters
 */
export class ProtoLocationsFilters extends ApiRequestFilters {
	/**
	 * Location type values to filter by
	 */
	types?: LocationTypeEnum[];

	/**
	 * Filter by pickup eligibility
	 */
	isPickUp?: BooleanFilterEnum;

	/**
	 * Filter by dropoff eligibility
	 */
	isDropOff?: BooleanFilterEnum;
}
